import { render } from "./tree.vue?vue&type=template&id=32353074&scoped=true&ts=true"
import script from "./tree.vue?vue&type=script&lang=ts"
export * from "./tree.vue?vue&type=script&lang=ts"

import "./tree.vue?vue&type=style&index=0&id=32353074&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32353074"]])

export default __exports__